<template>
  <v-layout id="login" align-center justify-center>
    <v-flex xs12 md6>
      <v-layout row align-center justify-center>
        <v-flex xs12 md10 lg8>
          <img class="logo" src="/static/images/logo.png">
          <v-toolbar-title class="toolbar-title">Nova senha</v-toolbar-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-text-field prepend-icon="fal fa-user" v-model="form.email"
                label="E-mail" type="text" disabled></v-text-field>
              <v-text-field prepend-icon="fal fa-shield-check" v-model="form.code"
                label="Código de confirmação" hint="Enviado por email" type="text"></v-text-field>
              <v-text-field prepend-icon="fal fa-lock" v-model="form.password"
                label="Nova senha" :append-icon="hidePassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                @click:append="() => (hidePassword = !hidePassword)"
                :type="hidePassword ? 'password' : 'text'"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="updatePassword()" round large depressed color="success"
                :loading="loadingRequest" :disabled="!valid">
                Definir nova senha
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6 fill-height class="login-image" hidden-sm-and-down></v-flex>
  </v-layout>
</template>

<script>
import router from '@/router'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'

export default {
  data: () => ({
    valid: true,
    loadingRequest: false,
    hidePassword: false,
    form: {
      password: ''
    }
  }),

  methods: {
    updatePassword () {
      Auth.forgotPasswordSubmit(this.form.email, this.form.code, this.form.password).then(data => {
        this.loadingRequest = false
        router.push({ name: 'Login' })

        EventBus.$emit('showSnackbar', {
          message: 'Senha alterada com sucesso!',
          color: 'success'
        })
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao definir nova senha',
          color: 'error'
        })
      })
    }
  },

  mounted () {
    this.form.email = this.$route.params.email
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginNewPassword.vue